// pages/legal/index.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { Link } from 'gatsby-theme-material-ui';
import { BigTextLogo } from '../../components/Logo'
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Footer from '../../components/Footer'
import { Helmet } from "react-helmet"
import { EULAContent, PrivacyPolicyContent } from '../../content/Legal.js'
import Bar from '../../components/Bar'

const ReactMarkdown = require('react-markdown/with-html')

const useStyles = makeStyles((theme) => 
  createStyles({
    divider: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3)
    }
  })
)

export default function Legal() {
  const classes = useStyles()
  return (
    <Fragment>
      <Bar/>
      <Container maxWidth="md">
        <Helmet>
          <meta charSet="utf-8" />
          <title>AMRC | Legal</title>
          <link rel="canonical" href="/legal" />
        </Helmet>
        <Box my={10}>
          <br/>
          <br/>
          <Typography variant="h4" component="h1" gutterBottom>
            Legal
          </Typography>
          <Link to="/legal#eula">EULA</Link>
          <br/>
          <Link to="/legal#privacy">Privacy Policy</Link>

          <Divider className={classes.divider}/>

          <Typography id="eula" variant="h5" component="h1" gutterBottom>
            End User License Agreement (EULA)
          </Typography>
          <ReactMarkdown
            source={EULAContent}
            escapeHtml={false}
          />

          <Divider className={classes.divider}/>

          <Typography id="privacy" variant="h5" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          <ReactMarkdown
            source={PrivacyPolicyContent}
            escapeHtml={false}
          />
        </Box>
        <Footer/>
      </Container>
    </Fragment>
  );
}
